







































import { Type, SetExpression, NoExpression, Expression, Types, PathExpression } from 'expangine-runtime';
import { TypeSettings } from '../../types/TypeVisuals';
import ExpressionBase from '../ExpressionBase';


export default ExpressionBase<SetExpression>().extend({
  name: 'SetEditor',
  data: () => ({
    valueSettings: null as null | TypeSettings,
  }),
  computed: {
    valueType(): Type | null {
      return this.value.path.getType(this.registry.defs, this.context);
    },
    valueTypeSimplified(): Type | null {
      return Types.simplify(this.valueType);
    },
  },
  methods: {
    setValueSettings(valueSettings: TypeSettings) {
      this.valueSettings = valueSettings;
    },
    clearValue() {
      this.value.value = NoExpression.instance;
      this.update();
    },
    setValue(value: Expression) {
      this.value.value = value;
      this.update();
    },
    setPath(path: PathExpression) {
      this.value.path = path;
      this.update();
    },
    clearPath() {
      this.value.path.expressions = [NoExpression.instance];
      this.update();
    },
  },
});
